







import { getDesignDeployDeployByMallNo } from '@/views/design/editor/api/deploy';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class DesignEditorButtonGroup extends Vue {
  private async deployDesign() {
    const { domain } = await getDesignDeployDeployByMallNo();
    alert('배포가 완료되었습니다.');
    window.open(`https://${domain}`, 'deploy');
  }
}
